import { render, staticRenderFns } from "./VideoThumbnail.vue?vue&type=template&id=6f8234e3&scoped=true&"
import script from "./VideoThumbnail.vue?vue&type=script&lang=js&"
export * from "./VideoThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./VideoThumbnail.vue?vue&type=style&index=0&id=6f8234e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8234e3",
  null
  
)

export default component.exports